import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["id"],
  _excluded2 = ["locale"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import Button from '@atlaskit/button/standard-button';
import { Checkbox } from '@atlaskit/checkbox';
import Form, { Field, Fieldset, RequiredAsterisk } from '@atlaskit/form';
import Link from '@atlaskit/link';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import SectionMessage from '@atlaskit/section-message';
import Select from '@atlaskit/select';
import TextArea from '@atlaskit/textarea';
import { N300 } from '@atlaskit/theme/colors';
import { messages } from '../messages';
import { IntlProviderWithResolvedMessages } from './IntlProviderWithResolvedMessages';
var FeedbackForm = function FeedbackForm(_ref) {
  var _ref$showTypeField = _ref.showTypeField,
    showTypeField = _ref$showTypeField === void 0 ? true : _ref$showTypeField,
    _ref$showDefaultTextF = _ref.showDefaultTextFields,
    showDefaultTextFields = _ref$showDefaultTextF === void 0 ? true : _ref$showDefaultTextF,
    customContent = _ref.customContent,
    onClose = _ref.onClose,
    onSubmit = _ref.onSubmit,
    feedbackTitle = _ref.feedbackTitle,
    feedbackTitleDetails = _ref.feedbackTitleDetails,
    feedbackGroupLabels = _ref.feedbackGroupLabels,
    summaryPlaceholder = _ref.summaryPlaceholder,
    canBeContactedLabel = _ref.canBeContactedLabel,
    enrolInResearchLabel = _ref.enrolInResearchLabel,
    submitButtonLabel = _ref.submitButtonLabel,
    cancelButtonLabel = _ref.cancelButtonLabel,
    anonymousFeedback = _ref.anonymousFeedback,
    hasDescriptionDefaultValue = _ref.hasDescriptionDefaultValue,
    selectLabel = _ref.selectLabel,
    customTextAreaLabel = _ref.customTextAreaLabel,
    _ref$customFeedbackOp = _ref.customFeedbackOptions,
    customFeedbackOptions = _ref$customFeedbackOp === void 0 ? [] : _ref$customFeedbackOp,
    shouldReturnFocusRef = _ref.shouldReturnFocusRef;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    canBeContacted = _useState2[0],
    setCanBeContacted = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    description = _useState4[0],
    setDescription = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    enrollInResearchGroup = _useState6[0],
    setEnrollInResearchGroup = _useState6[1];
  var _useState7 = useState('empty'),
    _useState8 = _slicedToArray(_useState7, 2),
    type = _useState8[0],
    setType = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isSubmitting = _useState10[0],
    setIsSubmitting = _useState10[1];
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var isTypeSelected = function isTypeSelected() {
    return type !== 'empty';
  };
  var canShowTextField = isTypeSelected() || !showTypeField;
  var hasDescription = description || hasDescriptionDefaultValue;
  var isDisabled = showTypeField ? !isTypeSelected() || !hasDescription : !hasDescription;
  var getFieldLabels = function getFieldLabels(record) {
    return {
      bug: (record === null || record === void 0 ? void 0 : record.bug.fieldLabel) || formatMessage(messages.formBugLabel),
      comment: (record === null || record === void 0 ? void 0 : record.comment.fieldLabel) || formatMessage(messages.formCommentLabel),
      suggestion: (record === null || record === void 0 ? void 0 : record.suggestion.fieldLabel) || formatMessage(messages.formSuggestionLabel),
      question: (record === null || record === void 0 ? void 0 : record.question.fieldLabel) || formatMessage(messages.formQuestionLabel),
      empty: (record === null || record === void 0 ? void 0 : record.empty.fieldLabel) || formatMessage(messages.formEmptyLabel)
    };
  };
  var getSelectOptions = function getSelectOptions(record) {
    return [{
      label: (record === null || record === void 0 ? void 0 : record.question.selectOptionLabel) || formatMessage(messages.selectionOptionQuestionLabel),
      value: 'question'
    }, {
      label: (record === null || record === void 0 ? void 0 : record.comment.selectOptionLabel) || formatMessage(messages.selectionOptionCommentLabel),
      value: 'comment'
    }, {
      label: (record === null || record === void 0 ? void 0 : record.bug.selectOptionLabel) || formatMessage(messages.selectionOptionBugLabel),
      value: 'bug'
    }, {
      label: (record === null || record === void 0 ? void 0 : record.suggestion.selectOptionLabel) || formatMessage(messages.selectionOptionSuggestionLabel),
      value: 'suggestion'
    }];
  };
  var getDefaultPlaceholder = function getDefaultPlaceholder(record) {
    return (record === null || record === void 0 ? void 0 : record.empty.selectOptionLabel) || formatMessage(messages.selectionOptionDefaultPlaceholder);
  };
  var focusRef = useRef();
  var selectOptions = customFeedbackOptions.length > 0 ? customFeedbackOptions : getSelectOptions(feedbackGroupLabels);
  return /*#__PURE__*/React.createElement(Modal, {
    shouldCloseOnOverlayClick: false,
    onClose: onClose,
    testId: "feedbackCollectorModalDialog",
    shouldReturnFocus: shouldReturnFocusRef,
    shouldScrollInViewport: true
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsSubmitting(true);
            _context.next = 3;
            return onSubmit({
              canBeContacted: canBeContacted,
              description: description,
              enrollInResearchGroup: enrollInResearchGroup,
              type: type
            });
          case 3:
            setIsSubmitting(false);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))
  }, function (_ref3) {
    var formProps = _ref3.formProps;
    return /*#__PURE__*/React.createElement("form", formProps, /*#__PURE__*/React.createElement(ModalHeader, {
      hasCloseButton: true
    }, /*#__PURE__*/React.createElement(ModalTitle, null, feedbackTitle || /*#__PURE__*/React.createElement(FormattedMessage, messages.feedbackTitle))), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement("p", {
      style: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        color: "var(--ds-text-subtle, ".concat(N300, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        marginBottom: "var(--ds-space-300, 24px)"
      }
    }, formatMessage(messages.requiredFieldsSummary), /*#__PURE__*/React.createElement(RequiredAsterisk, null)), feedbackTitleDetails, customContent, showTypeField ? /*#__PURE__*/React.createElement(Field, {
      name: "topic",
      label: selectLabel || formatMessage(messages.selectionOptionDefaultLabel),
      isRequired: true,
      "aria-required": true // JCA11Y-1619
    }, function (_ref4) {
      var _ref4$fieldProps = _ref4.fieldProps,
        id = _ref4$fieldProps.id,
        restProps = _objectWithoutProperties(_ref4$fieldProps, _excluded);
      return /*#__PURE__*/React.createElement(Select, _extends({}, restProps, {
        onChange: function onChange(option) {
          if (!option || option instanceof Array) {
            return;
          }
          setType(option.value);
        },
        menuPortalTarget: document.body,
        styles: {
          menuPortal: function menuPortal(base) {
            return _objectSpread(_objectSpread({}, base), {}, {
              zIndex: 9999
            });
          }
        },
        options: selectOptions
        // @ts-ignore
        ,
        ref: focusRef,
        placeholder: getDefaultPlaceholder(feedbackGroupLabels),
        inputId: id
      }));
    }) : null, showDefaultTextFields && canShowTextField && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
      label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage(messages.defaultCustomTextAreaLabel),
      isRequired: true,
      name: "description"
    }, function (_ref5) {
      var fieldProps = _ref5.fieldProps;
      return /*#__PURE__*/React.createElement(TextArea, _extends({}, fieldProps, {
        name: "foo",
        minimumRows: 6,
        placeholder: summaryPlaceholder || undefined,
        onChange: function onChange(e) {
          return setDescription(e.target.value);
        },
        value: description
      }));
    }), !anonymousFeedback && /*#__PURE__*/React.createElement(Fieldset, null, /*#__PURE__*/React.createElement("legend", {
      "aria-hidden": false,
      hidden: true
    }, "Atlassian opt-in options"), /*#__PURE__*/React.createElement(Field, {
      name: "can-be-contacted"
    }, function (_ref6) {
      var fieldProps = _ref6.fieldProps;
      return /*#__PURE__*/React.createElement(Checkbox, _extends({}, fieldProps, {
        "aria-describedby": undefined // JCA11Y-1988
        ,
        label: canBeContactedLabel || /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.canBeContactedLabel, {
          values: {
            a: function a(chunks) {
              return /*#__PURE__*/React.createElement(Link, {
                href: "https://www.atlassian.com/legal/privacy-policy",
                target: "_blank"
              }, chunks);
            }
          }
        })),
        onChange: function onChange(event) {
          return setCanBeContacted(event.target.checked);
        }
      }));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "enroll-in-research-group"
    }, function (_ref7) {
      var fieldProps = _ref7.fieldProps;
      return /*#__PURE__*/React.createElement(Checkbox, _extends({}, fieldProps, {
        "aria-describedby": undefined // JCA11Y-1988
        ,
        label: enrolInResearchLabel || formatMessage(messages.enrolInResearchLabel),
        onChange: function onChange(event) {
          return setEnrollInResearchGroup(event.target.checked);
        }
      }));
    })) || /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
      name: 'anonymousFeedback'
    }, function () {
      return /*#__PURE__*/React.createElement(SectionMessage, {
        title: formatMessage(messages.feedbackIsAnonymousTitle),
        appearance: 'information'
      }, /*#__PURE__*/React.createElement("p", null, formatMessage(messages.feedbackIsAnonymous)));
    })))), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
      appearance: "subtle",
      onClick: onClose
    }, cancelButtonLabel || /*#__PURE__*/React.createElement(FormattedMessage, messages.cancelButtonLabel)), /*#__PURE__*/React.createElement(Button, {
      appearance: "primary",
      type: "submit",
      isDisabled: isSubmitting || isDisabled,
      testId: "feedbackCollectorSubmitBtn"
    }, submitButtonLabel || /*#__PURE__*/React.createElement(FormattedMessage, messages.submitButtonLabel))));
  }));
};
var FeedbackFormWithIntl = function FeedbackFormWithIntl(_ref8) {
  var locale = _ref8.locale,
    props = _objectWithoutProperties(_ref8, _excluded2);
  return /*#__PURE__*/React.createElement(IntlProviderWithResolvedMessages, {
    locale: locale
  }, /*#__PURE__*/React.createElement(FeedbackForm, props));
};
export default FeedbackFormWithIntl;